export default __webpack_public_path__ + "static/media/slider1.5c7e8362.jpg";